import React, { useState, useEffect, useContext, createContext } from "react"
import firebase from "../lib/firebase"
// import { createUser } from "./db"
import { gql } from "@apollo/client"
import apollo from "../lib/apollo/index"

const authContext = createContext()

export function AuthProvider({ children }) {
  const auth = useFirebaseAuth()
  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

export const useAuth = () => {
  return useContext(authContext)
}

function useFirebaseAuth() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [role, setRole] = useState(null)

  useEffect(() => {
    const get = async () => {
      const { data, ...rest } = await apollo.query({
        query: gql`
          query Me {
            me {
              id
              role
            }
          }
        `,
      })

      setRole(data?.me?.role)
    }

    if (!role) {
      get()
    }
  }, [apollo, role])

  const handleUser = async (_user) => {
    // if (!user) {
    //   setUser(null);
    //   nookies.set(undefined, 'token', '', { path: '/' });
    // } else {
    //   const token = await user.getIdToken();
    //   setUser(user);
    //   nookies.set(undefined, 'token', token, { path: '/' });
    // }

    if (_user) {
      const user = await formatUser(_user)
      const token = await _user.getIdToken()
      localStorage.setItem("token", token)

      setUser(user)
      setLoading(false)
      return user
    } else {
      setUser(false)
      setLoading(false)
      return false
    }
  }

  // const signinWithGoogle = (redirect) => {
  //   setLoading(true)
  //   return firebase
  //     .auth()
  //     .signInWithPopup(new firebase.auth.GoogleAuthProvider())
  //     .then((response) => {
  //       handleUser(response.user)

  //       if (redirect) {
  //         //   .push(redirect)
  //       }
  //     })
  // }

  const signInWithEmailAndPassword = ({ email, password }) => {
    return firebase.auth().signInWithEmailAndPassword(email, password)
  }

  const signout = () => {
    return firebase
      .auth()
      .signOut()
      .then(() => handleUser(false))
  }

  const reloadCurrentUser = () => {
    return firebase
      .auth()
      .currentUser.reload()
      .then(() => {
        handleUser(firebase.auth().currentUser)
      })
  }

  const reauthenticate = (currentPassword) => {
    var user = firebase.auth().currentUser
    var cred = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword,
    )
    return user.reauthenticateWithCredential(cred)
  }

  const updateProfile = (data) => {
    return firebase.auth().currentUser.updateProfile(data)
  }

  const updatePassword = (data) => {
    return firebase.auth().currentUser.updatePassword(data)
  }

  const forgotPassword = (email) => {
    return firebase.auth().sendPasswordResetEmail(email)
  }

  const restPassword = ({ code, password }) => {
    return firebase.auth().confirmPasswordReset(code, password)
  }

  useEffect(() => {
    const unsubscribe = firebase.auth().onIdTokenChanged(handleUser)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // // User is signed in, see docs for a list of available properties
        // // https://firebase.google.com/docs/reference/js/firebase.User
        // var uid = user.uid;
        // // ...
      } else {
        // User is signed out
        // ...
      }
    })

    return () => unsubscribe()
  }, [])

  return {
    user,
    role,
    token: localStorage.getItem("token"),
    loading,
    signInWithEmailAndPassword,
    signout,
    reloadCurrentUser,
    reauthenticate,
    updateProfile,
    updatePassword,
    forgotPassword,
    restPassword,
  }
}

const formatUser = async (user) => {
  return {
    // uid: user.uid,
    id: user.uid,
    email: user.email,
    // name: user.displayName,
    displayName: user.displayName,
    // provider: user.providerData[0].providerId,
    photoURL: user.photoURL,
    phoneNumber: user?.phoneNumber,
  }
}
